<app-page-breadcrumb pageTitle="Reglas de Descuento"></app-page-breadcrumb>

<div class="space-y-5">
  <!-- Header -->
  <div class="flex flex-wrap items-center justify-between gap-3">
    <p class="text-sm text-gray-500 dark:text-gray-400">
      Define reglas de descuento por volumen, contractuales, cupones y precios
      mínimos
    </p>
    <div class="flex items-center gap-2">
      <button
        type="button"
        (click)="toggleFilters()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 flex items-center gap-1.5"
      >
        Filtros
      </button>
      <button
        type="button"
        (click)="toggleCouponTester()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 flex items-center gap-1.5"
      >
        Probar cupón
      </button>
      <button
        type="button"
        (click)="nuevaRegla()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 4v16m8-8H4"
          ></path>
        </svg>
        Nueva Regla
      </button>
    </div>
  </div>

  @if (error) {
    <div
      class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20"
    >
      <p class="text-sm text-error-600 dark:text-error-400">{{ error }}</p>
    </div>
  }

  <!-- Filtros -->
  @if (showFilters) {
    <div
      class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-5"
    >
      <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div>
          <label
            class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1"
            >Tipo de regla</label
          >
          <select
            [(ngModel)]="filtroRuleType"
            (ngModelChange)="buscar()"
            class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
          >
            <option [ngValue]="undefined">Todos</option>
            <option value="volume">Volumen</option>
            <option value="contractual">Contractual</option>
            <option value="coupon">Cupón</option>
            <option value="min_price">Precio mínimo</option>
          </select>
        </div>
        <div>
          <label
            class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1"
            >Código de cupón</label
          >
          <input
            type="text"
            [(ngModel)]="filtroCouponCode"
            (ngModelChange)="buscar()"
            placeholder="Buscar cupón"
            class="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
          />
        </div>
        <div class="flex items-end">
          <button
            type="button"
            (click)="limpiarFiltro()"
            class="w-full px-3 py-2 text-sm rounded-lg font-medium bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600"
          >
            Limpiar
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Coupon tester -->
  @if (showCouponTester) {
    <div
      class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-5 space-y-4"
    >
      <h3 class="text-sm font-semibold text-gray-700 dark:text-gray-300">
        Probar Cupón
      </h3>

      @if (couponError) {
        <div
          class="p-3 bg-error-50 border border-error-200 rounded-lg dark:bg-error-900/20 dark:border-error-800"
        >
          <p class="text-sm text-error-600 dark:text-error-400">
            {{ couponError }}
          </p>
        </div>
      }

      <div class="grid grid-cols-1 sm:grid-cols-4 gap-3">
        <div>
          <label
            class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1"
            >Código <span class="text-error-500">*</span></label
          >
          <input
            type="text"
            [(ngModel)]="couponCode"
            placeholder="SUMMER20"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white"
          />
        </div>

        <div class="flex items-end">
          <button
            type="button"
            (click)="probarCupon()"
            [disabled]="
              testingCoupon ||
              (!couponMaxUses && !couponProductId && !couponCode)
            "
            class="w-full px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {{ testingCoupon ? 'Aplicando...' : 'Aplicar' }}
          </button>
        </div>
      </div>

      @if (couponResult) {
        <div
          class="p-4 flex gap-4 border rounded-lg"
          [class.bg-success-50]="couponResult.couponStatus === 'ACTIVE'"
          [class.border-success-200]="couponResult.couponStatus === 'ACTIVE'"
          [class.dark:bg-success-900/20]="
            couponResult.couponStatus === 'ACTIVE'
          "
          [class.dark:border-success-800]="
            couponResult.couponStatus === 'ACTIVE'
          "
          [class.bg-gray-50]="couponResult.couponStatus === 'INACTIVE'"
          [class.border-gray-200]="couponResult.couponStatus === 'INACTIVE'"
          [class.dark:bg-gray-900/20]="couponResult.couponStatus === 'INACTIVE'"
          [class.dark:border-gray-800]="
            couponResult.couponStatus === 'INACTIVE'
          "
          [class.bg-warning-50]="couponResult.couponStatus === 'NOT_STARTED'"
          [class.border-warning-200]="
            couponResult.couponStatus === 'NOT_STARTED'
          "
          [class.dark:bg-warning-900/20]="
            couponResult.couponStatus === 'NOT_STARTED'
          "
          [class.dark:border-warning-800]="
            couponResult.couponStatus === 'NOT_STARTED'
          "
          [class.bg-error-50]="
            couponResult.couponStatus === 'EXPIRED' ||
            couponResult.couponStatus === 'MAX_USES_REACHED'
          "
          [class.border-error-200]="
            couponResult.couponStatus === 'EXPIRED' ||
            couponResult.couponStatus === 'MAX_USES_REACHED'
          "
          [class.dark:bg-error-900/20]="
            couponResult.couponStatus === 'EXPIRED' ||
            couponResult.couponStatus === 'MAX_USES_REACHED'
          "
          [class.dark:border-error-800]="
            couponResult.couponStatus === 'EXPIRED' ||
            couponResult.couponStatus === 'MAX_USES_REACHED'
          "
        >
          <div class="flex flex-wrap gap-4 text-sm">
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Código</p>
              <p class="font-semibold text-gray-800 dark:text-white">
                {{ couponResult.coupon_code }}
              </p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Producto</p>
              <p class="font-bold text-brand-600 dark:text-brand-400">
                {{ couponResult.name }}
              </p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">
                Precio base
              </p>
              <p class="font-bold text-gray-600 dark:text-gray-400">
                {{ getFormatedPrice(couponResult.price) }}
              </p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Ahorrado</p>
              <p class="font-bold text-gray-600 dark:text-gray-400">
                {{ getFormatedPrice(couponResult.discountAmount) }}
              </p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Estado</p>
              <p
                class="font-bold"
                [class.text-gray-600]="couponResult.couponStatus === 'INACTIVE'"
                [class.dark:text-gray-400]="
                  couponResult.couponStatus === 'INACTIVE'
                "
                [class.text-warning-600]="
                  couponResult.couponStatus === 'NOT_STARTED'
                "
                [class.dark:text-warning-400]="
                  couponResult.couponStatus === 'NOT_STARTED'
                "
                [class.text-error-600]="couponResult.couponStatus === 'EXPIRED'"
                [class.dark:text-error-400]="
                  couponResult.couponStatus === 'EXPIRED' ||
                  couponResult.couponStatus === 'MAX_USES_REACHED'
                "
                [class.text-error-600]="
                  couponResult.couponStatus === 'EXPIRED' ||
                  couponResult.couponStatus === 'MAX_USES_REACHED'
                "
                [class.dark:text-error-400]="
                  couponResult.couponStatus === 'EXPIRED' ||
                  couponResult.couponStatus === 'MAX_USES_REACHED'
                "
                [class.text-success-600]="
                  couponResult.couponStatus === 'ACTIVE'
                "
                [class.dark:text-success-400]="
                  couponResult.couponStatus === 'ACTIVE'
                "
              >
                {{ getCouponStatusLabel(couponResult.couponStatus) }}
              </p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Tipo</p>
              <p class="font-medium text-gray-700 dark:text-gray-300">
                {{ getDiscountType() }}
              </p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">Valor</p>
              <p class="font-medium text-gray-700 dark:text-gray-300">
                {{ resolverValueCoupon(couponResult) }}
              </p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">
                Disponibilidad
              </p>
              <p class="font-medium text-gray-700 dark:text-gray-300">
                {{ resolverLimitedCouponDate(couponResult) }}
              </p>
            </div>

            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">
                Precio promoción
              </p>
              <p class="font-bold text-gray-600 dark:text-gray-400">
                @if (
                  couponResult.promo_enabled && couponResult.promo_price > 0
                ) {
                  {{ getFormatedPrice(couponResult.promo_price) }}
                } @else {
                  Inactiva
                }
              </p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">
                Usos disponibles
              </p>
              <p class="font-bold text-brand-600 dark:text-brand-400">
                {{ couponResult.max_uses - couponResult.current_uses }}
              </p>
            </div>
            <div>
              <p class="text-xs text-gray-500 dark:text-gray-400">
                Precio Final
              </p>
              <p class="font-bold text-success-600 dark:text-success-400">
                {{ getFormatedPrice(couponResult.finalPrice) }}
              </p>
            </div>
          </div>
        </div>
      }
    </div>
  }

  <!-- Tabla de reglas -->
  <div
    class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/3"
  >
    @if (loading) {
      <div class="flex justify-center items-center py-10">
        <div
          class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"
        ></div>
        <span class="ml-3 text-gray-500 dark:text-gray-400 text-sm"
          >Cargando reglas...</span
        >
      </div>
    } @else if (rules.length === 0) {
      <div class="text-center py-10 text-gray-500 dark:text-gray-400">
        <p class="text-sm">No hay reglas de descuento registradas.</p>
      </div>
    } @else {
      <div class="max-w-full overflow-x-auto">
        <table class="min-w-full">
          <thead class="border-b border-gray-100 dark:border-white/5">
            <tr>
              <th
                class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400"
              >
                Tipo
              </th>
              <th
                class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400"
              >
                Producto
              </th>
              <th
                class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400"
              >
                Descuento
              </th>
              <th
                class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400"
              >
                Vigencia
              </th>
              <th
                class="px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400"
              >
                Estado
              </th>
              <th
                class="px-4 py-3 text-right text-xs font-medium text-gray-500 dark:text-gray-400"
              >
                Usos
              </th>
              <th
                class="px-4 py-3 text-center text-xs font-medium text-gray-500 dark:text-gray-400"
              >
                Acciones
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-white/5">
            @for (rule of rules; track rule.id) {
              <tr>
                <td class="px-4 py-3">
                  <span
                    class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300"
                  >
                    {{ getRuleTypeLabel(rule.ruleType) }}
                  </span>
                </td>
                <td class="px-4 py-3 text-sm text-gray-700 dark:text-gray-300">
                  {{ getProductLabel(rule) }}
                </td>
                <td
                  class="px-4 py-3 text-sm font-semibold text-brand-600 dark:text-brand-400"
                >
                  {{ getDiscountLabel(rule) }}
                </td>
                <td class="px-4 py-3 text-xs text-gray-500 dark:text-gray-400">
                  @if (rule.validFrom || rule.validUntil) {
                    {{ formatDate(rule.validFrom) }} -
                    {{ formatDate(rule.validUntil) }}
                  } @else {
                    Sin vigencia
                  }
                </td>
                <td class="px-4 py-3 text-center">
                  <div>
                    <span
                      class="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium"
                      [class]="resolveStatus(rule).color"
                      >{{ resolveStatus(rule).status }}</span
                    >
                  </div>
                </td>
                <td
                  class="px-4 py-3 text-right text-xs text-gray-600 dark:text-gray-400"
                >
                  @if (rule.maxUses) {
                    {{ rule.currentUses ?? 0 }} / {{ rule.maxUses }}
                  } @else {
                    -
                  }
                </td>
                <td class="px-4 py-3">
                  <div class="flex items-center justify-center gap-1">
                    <button
                      type="button"
                      (click)="verDetalle(rule)"
                      class="rounded p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                      title="Ver detalle"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        ></path>
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        ></path>
                      </svg>
                    </button>
                    <button
                      type="button"
                      (click)="editarRegla(rule)"
                      class="rounded p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
                      title="Editar"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                        ></path>
                      </svg>
                    </button>
                    <button
                      type="button"
                      (click)="eliminarRegla(rule)"
                      class="rounded p-1.5 hover:bg-error-50 hover:text-error-600 text-gray-400"
                      title="Eliminar"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>

<app-discount-rule-detail-modal
  [isOpen]="showDetailModal"
  [rule]="selectedRule"
  (close)="cerrarModal()"
/>
